import { Flex, Typography } from "@aircall/tractor";
import { styled } from "@xstyled/styled-components";

import { Container } from "../TranscriptionItem/TranscriptionItem.styled";

type DetailsProps = { active: boolean };

export const Details = styled(Flex).attrs({
  className: "transcript_details",
  flexDirection: "column",
  alignItems: "end",
})<DetailsProps>`
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: all 0.3s;
  cursor: pointer;

  .transcript_item:hover & {
    opacity: 1;
  }
`;

export const ItemActions = styled(Flex).attrs({
  // these attrs are meant to increase the hoverable area of the icon
  paddingX: "8px",
  height: "100%",
  alignItems: "center",
  justifyContents: "start",
})`
  gap: xs;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease-out;

  ${Container}:hover & {
    opacity: 1;
  }

  &:hover {
    svg {
      color: icon-interactive-default;
    }
  }
`;

export const SpeakerName = styled(Typography).attrs({
  variant: "bodyMediumS",
  color: "text-base",
  ellipsis: true,
})`
  max-width: 150px;
`;
